import * as Model from '../models';

export type OligRequestParam = {
  researcherName: Model.Parameter;
  oligoName: Model.Parameter;
  oligoValue: Model.Parameter;
  scale: Model.Parameter;
  purification: Model.Parameter;
  format: Model.Parameter;
  prime5Mod: Model.Parameter;
  prime3Mod: Model.Parameter;
  delivery: Model.Parameter;
  alternate: Model.Parameter[];
  handling: Model.Parameter[];
};

/* tslint:disable:prefer-for-of */
export function getCookie(cname: string): string {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) !== -1) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function replaceKeys<U extends object>(target: any, propertyKeyMap: { [key: string]: string }): U {
  if (!target) {
    return target;
  }
  const build = {} as U;
  for (const key in target) {
    if (target[key]) {
      const srcKey = key as string;
      // Get the destination key
      const destKey = propertyKeyMap[srcKey] || srcKey;
      // Get the value
      let value = target[srcKey];
      // If this is an object, recurse
      if (typeof value === 'object' && !Array.isArray(value)) {
          value = replaceKeys(value, propertyKeyMap);
      }
      // Set it on the result using the destination key
      build[destKey] = value;
    } else {
      const srcKey = key as string;
      const destKey = propertyKeyMap[srcKey] || srcKey;
      const value = target[srcKey];
      build[destKey] = value;
    }
  }
  return build;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/service/common.ts